import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';

/**
 *
 * @param initialState inital state
 * @param delay debounce delay
 * @returns state: state value
 * @returns setState: set state value
 * @returns debounceState: state that can be used for api call
 * @returns setDebouncedState: immediately set state without debounce
 */

export default function useDebounceState<T>(initialState: T | (() => T), delay = 200) {
  const [state, setState] = useState(initialState);
  const [debounceState, setDebouncedState] = useState(
    typeof initialState === 'function' ? (initialState as () => T)() : initialState,
  );

  // sync local state when value changes from the parent i.e clearFilters or clearSearch
  useEffect(() => {
    const current = typeof initialState === 'function' ? (initialState as () => T)() : initialState;
    setState(current);
    setDebouncedState(current);
  }, [initialState]);

  useDebounce(() => setDebouncedState(state), delay, [state]);

  return [state, setState, debounceState, setDebouncedState] as [
    T,
    typeof setState,
    T,
    typeof setState,
  ];
}
